import './index.css'

// VITE_PLATFORM is statically replaced at build time, so the untaken branch —
// and the entire platform tree behind it — is eliminated from the bundle.
if (import.meta.env.VITE_PLATFORM === 'desktop') {
  await import('@/desktop/main')
} else {
  await import('@/mobile/main')
}
